export const maintenanceDataPorTipo = {
    "MOTONIVELADORA": [
      {
        id: 1,
        seccion: "MOTOR",
        descripcion: "Cambio Aceite de Motor",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 2,
        seccion: "MOTOR",
        descripcion: "Cambio Filtros de Aceite Motor",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 3,
        seccion: "MOTOR",
        descripcion: "Cambio filtros de combustible (Principal, secuandario, sedimantación)",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 4,
        seccion: "MOTOR",
        descripcion: "Comprobar el estado del turbo cargador (modelos aplicables)",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 5,
        seccion: "MOTOR",
        descripcion: "Comprobar nivel de aceite en motor",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 6,
        seccion: "MOTOR",
        descripcion: "Comprobar nivel de refrigerante",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 7,
        seccion: "MOTOR",
        descripcion: "Control y apriete las abrazaderas del circuito refrigerante",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 8,
        seccion: "MOTOR",
        descripcion: "Drenar tanque de combustible",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 9,
        seccion: "MOTOR",
        descripcion: "Comprobar y ajustar escape",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 10,
        seccion: "MOTOR",
        descripcion: "Control y apriete de entrada de aire y conectores",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 11,
        seccion: "FILTROS DE AIRE",
        descripcion: "Compruebe el indicador del filtro de aire",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 12,
        seccion: "FILTROS DE AIRE",
        descripcion: "Limpiar el deposito del filtro de aire",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 13,
        seccion: "FILTROS DE AIRE",
        descripcion: "Cambiar los filtros principales de aire",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 14,
        seccion: "FILTROS DE AIRE",
        descripcion: "Cambiar los filtros secundarios de aire",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 15,
        seccion: "FILTROS DE AIRE",
        descripcion: "Comprobar y ajustar el cinturon porta filtro",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 16,
        seccion: "ACCESORIOS",
        descripcion: "Comrpobar KIT de Herramientas",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 17,
        seccion: "ACCESORIOS",
        descripcion: "Comprobar manuales de partes /OyM",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 18,
        seccion: "FRENOS",
        descripcion: "Chequear el estado de los frenos",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 19,
        seccion: "FRENOS",
        descripcion: "Reemplazar liquido de frenos",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 20,
        seccion: "FRENOS",
        descripcion: "Apriete de las ruedas",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 21,
        seccion: "FRENOS",
        descripcion: "Comprobar el estado de los neumáticos",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 22,
        seccion: "CABINA",
        descripcion: "Comprobar el funcionamiento de todos los instrumentos",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 23,
        seccion: "CABINA",
        descripcion: "Comprobar ruidos inusuales",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 24,
        seccion: "CABINA",
        descripcion: "Comrprobar el funcionamiento de todos los controles de operación",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 25,
        seccion: "CABINA",
        descripcion: "Comprobar y ajustar las palancas de operación",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 26,
        seccion: "TRANSMISIÓN",
        descripcion: "Chequear nivel de aceite de transmisión",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 27,
        seccion: "TRANSMISIÓN",
        descripcion: "Reemplazar aceite de transmisión",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 28,
        seccion: "TRANSMISIÓN",
        descripcion: "Comprobar el nivel de aceite de diferenciales",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 29,
        seccion: "TRANSMISIÓN",
        descripcion: "Reemplazar aceite de diferenciales",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 30,
        seccion: "TRANSMISIÓN",
        descripcion: "Reemplazar aceite del convertidor par",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 31,
        seccion: "TRANSMISIÓN",
        descripcion: "Comprobar el estado de eje de tracción",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 32,
        seccion: "ENGRRASE",
        descripcion: "Realizar servicio de engrase en todos los puntos indicados por el manual de OyM",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 33,
        seccion: "SIST. ELÉCTRICO",
        descripcion: "Comprobar el estado de las baterías",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 34,
        seccion: "SIST. ELÉCTRICO",
        descripcion: "Comprobar luces",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 35,
        seccion: "SIST. ELÉCTRICO",
        descripcion: "Comprobar alarma / bocina",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 36,
        seccion: "CHÁSIS",
        descripcion: "Ajuste de todos los pernos y bulones",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 37,
        seccion: "CHÁSIS",
        descripcion: "Chquear perdida de aceite",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 38,
        seccion: "CHÁSIS",
        descripcion: "Chequear estribos y perifericos de estructura",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 39,
        seccion: "EQUIPO DE TRABAJO",
        descripcion: "Comprobar el nivel de aceite hidráulico",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 40,
        seccion: "EQUIPO DE TRABAJO",
        descripcion: "Chequear el estado de las cadenas",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 41,
        seccion: "EQUIPO DE TRABAJO",
        descripcion: "Reemplzar aceite hidráulico",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 42,
        seccion: "EQUIPO DE TRABAJO",
        descripcion: "Comprobar el estado de la torre y rodamiento",
        condicion: "Buena",
        updatedAt: null
      },
      {
        id: 43,
        seccion: "EQUIPO DE TRABAJO",
        descripcion: "Comprobar el estado de las cadenas",
        condicion: "Buena",
        updatedAt: null
      }
    ],
  
    // ⚠️ Podés copiar el array anterior como base y adaptarlo a los otros tipos:
   "MINICARGADOR": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 13, seccion: "FILTROS DE AIRE", descripcion: "Compruebe el Indicador del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el Depósito del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Principales de Aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Secundarios de Aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y Ajustar el Cinturón Porta Filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 18, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // SISTEMA HIDRÁULICO
    { id: 20, seccion: "SISTEMA HIDRÁULICO", descripcion: "Comprobar nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar aceite Hidráulico", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 22, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },

    // SIST. DE TRASLADO
    { id: 25, seccion: "SIST. DE TRASLADO", descripcion: "Comprobar y ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "SIST. DE TRASLADO", descripcion: "Chequear la Tensión de las Cadenas", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "SIST. DE TRASLADO", descripcion: "Comprobar el Pistón de Frenos", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "SIST. DE TRASLADO", descripcion: "Comprobar la presión de los Neumáticos", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 29, seccion: "ENGRASE", descripcion: "Realizar servicio de Engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 30, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las Baterías", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarmas / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 33, seccion: "CHASIS", descripcion: "Ajuste de Todos los Pernos", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "CHASIS", descripcion: "Chequear Pérdidas de Aceite", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "CHASIS", descripcion: "Comprobar el Pasador Frontal del Bastidor", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CHASIS", descripcion: "Comprobar y Ajustar los Pernos del Equipo de Trabajo", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CHASIS", descripcion: "Comprobar el ajuste de los Neumáticos", condicion: "Buena", updatedAt: null },
    { id: 38, seccion: "CHASIS", descripcion: "Comprobar el nivel de Combustible", condicion: "Buena", updatedAt: null }
  ],
  "PALACARGADORA": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Apriete Tapa de Cilindros", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Comprobar la presión de aceite", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Compruebe el Indicador del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el Depósito del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Principales de Aire", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Secundarios de Aire", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y Ajustar el Cinturón Porta Filtro", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN
    { id: 20, seccion: "TRANSMISIÓN", descripcion: "Comprobar el estado de la Transmisión", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "TRANSMISIÓN", descripcion: "Comprobar el nivel de aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "TRANSMISIÓN", descripcion: "Cambio de Aceite de Transmisión", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "TRANSMISIÓN", descripcion: "Comprobar el nivel de Aceite Mandos Finales", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "TRANSMISIÓN", descripcion: "Cambio Aceite Mandos Finales", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "TRANSMISIÓN", descripcion: "Reemplazo Filtros de Transmisión", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 26, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // SISTEMA HIDRÁULICO
    { id: 28, seccion: "SISTEMA HIDRÁULICO", descripcion: "Comprobar el Estado del Equipo de Trabajo", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "SISTEMA HIDRÁULICO", descripcion: "Comprobar el Nivel de Aceite Hidráulico", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar el Aceite Hidráulico", condicion: "Buena", updatedAt: null },

    // EJES PORTALES / TRASERO
    { id: 31, seccion: "EJES PORTALES / TRASERO", descripcion: "Cambio Aceite Diferencial", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "EJES PORTALES / TRASERO", descripcion: "Reemplazo de Filtros", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar y Engrasar las Cruzetas", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el Nivel de Aceite de los diferenciales", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el Estado del Cardan", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 36, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de Todos los Instrumentos", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 38, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "CABINA", descripcion: "Comprobar y Ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "CABINA", descripcion: "Control y Apriete de Cabina", condicion: "Buena", updatedAt: null },

    // FRENOS
    { id: 41, seccion: "FRENOS", descripcion: "Cambiar Filtro de Aire del Circuito de Frenos", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "FRENOS", descripcion: "Comprobar el Funcionamiento de los Frenos", condicion: "Buena", updatedAt: null },
    { id: 43, seccion: "FRENOS", descripcion: "Drenar el Agua del Depósito de Aire", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "FRENOS", descripcion: "Comprobar y Ajustar la Válvula de Regulación de Presión", condicion: "Buena", updatedAt: null },
    { id: 45, seccion: "FRENOS", descripcion: "Comprobar el Apriete de las Llantas", condicion: "Buena", updatedAt: null },
    { id: 46, seccion: "FRENOS", descripcion: "Comprobar la Presión de los Neumáticos", condicion: "Buena", updatedAt: null },
    { id: 47, seccion: "FRENOS", descripcion: "Comprobar y Ajustar el Freno de Mano", condicion: "Buena", updatedAt: null },
    { id: 48, seccion: "FRENOS", descripcion: "Comprobar el Desgaste de los Frenos", condicion: "Buena", updatedAt: null },

    // DIRECCIÓN
    { id: 49, seccion: "DIRECCIÓN", descripcion: "Comprobar los Cilindros de Dirección", condicion: "Buena", updatedAt: null },
    { id: 50, seccion: "DIRECCIÓN", descripcion: "Comprobar el Estado de las Mangueras", condicion: "Buena", updatedAt: null },
    { id: 51, seccion: "DIRECCIÓN", descripcion: "Comprobar la Alineación del Volante", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 52, seccion: "ENGRASE", descripcion: "Realizar Servicio de Engrase en todos los Puntos indicados por el Manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 53, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el Estado de Baterías", condicion: "Buena", updatedAt: null },
    { id: 54, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Luces y Limpia Parabrisas", condicion: "Buena", updatedAt: null },
    { id: 55, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarma / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 56, seccion: "CHASIS", descripcion: "Ajuste de Todos los Pernos", condicion: "Buena", updatedAt: null },
    { id: 57, seccion: "CHASIS", descripcion: "Chequear Pérdidas de Aceite", condicion: "Buena", updatedAt: null },
    { id: 58, seccion: "CHASIS", descripcion: "Comprobar el Pasador Frontal del Bastidor", condicion: "Buena", updatedAt: null },
    { id: 59, seccion: "CHASIS", descripcion: "Comprobar y Ajustar los Pernos del Equipo de Trabajo", condicion: "Buena", updatedAt: null },
    { id: 60, seccion: "CHASIS", descripcion: "Comprobar el ajuste de los neumáticos", condicion: "Buena", updatedAt: null },
    { id: 61, seccion: "CHASIS", descripcion: "Comprobar el nivel de combustible", condicion: "Buena", updatedAt: null }
  ],
  "PALA-RETRO": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // SISTEMA HIDRÁULICO
    { id: 13, seccion: "SISTEMA HIDRÁULICO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Comprobar fugas de aceite en el cinturón portafiltros", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y Ajustar el Cinturón Porta Filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 18, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 20, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de Todos los Instrumentos", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "CABINA", descripcion: "Comprobar y ajustar las palancas de operación", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN / RUEDAS
    { id: 24, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar y apretar los neumáticos", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar el nivel de aceite transmisión", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Reemplazar el aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar el nivel de aceite diferencial", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Reemplazar el aceite diferencial", condicion: "Buena", updatedAt: null },

    // SERVICIO
    { id: 29, seccion: "SERVICIO", descripcion: "Realizar servicio de engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 30, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las baterías", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas (Modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarmas / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 33, seccion: "CHASIS", descripcion: "Ajuste de todos los pernos y tornillos", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "CHASIS", descripcion: "Comprobar el estado del equipo de trabajo (Pala)", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "CHASIS", descripcion: "Comprobar el estado del equipo de trabajo (Retro)", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CHASIS", descripcion: "Comprobar el estado de la carrocería", condicion: "Buena", updatedAt: null },

    // HIDRÁULICO
    { id: 38, seccion: "HIDRÁULICO", descripcion: "Comprobar nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null }
  ],
  "EXCAVADORA HIDRAULICA": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // SISTEMA HIDRÁULICO
    { id: 13, seccion: "SISTEMA HIDRÁULICO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Comprobar fugas de aceite en el cinturón portafiltros", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y Ajustar el Cinturón Porta Filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 18, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 20, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de Todos los Instrumentos", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "CABINA", descripcion: "Comprobar y ajustar las palancas de operación", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN / RUEDAS
    { id: 24, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar y apretar los neumáticos", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar el nivel de aceite transmisión", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Reemplazar el aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Comprobar el nivel de aceite diferencial", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "TRANSMISIÓN / RUEDAS", descripcion: "Reemplazar el aceite diferencial", condicion: "Buena", updatedAt: null },

    // SERVICIO
    { id: 29, seccion: "SERVICIO", descripcion: "Realizar servicio de engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 30, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las baterías", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas (Modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarmas / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 33, seccion: "CHASIS", descripcion: "Ajuste de todos los pernos y tornillos", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "CHASIS", descripcion: "Comprobar el estado del equipo de trabajo (Pala)", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "CHASIS", descripcion: "Comprobar el estado del equipo de trabajo (Retro)", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CHASIS", descripcion: "Comprobar el estado de la carrocería", condicion: "Buena", updatedAt: null },

    // HIDRÁULICO
    { id: 38, seccion: "HIDRÁULICO", descripcion: "Comprobar nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null }
  ], 
  "HIDROGRUA": [
    // ESTRUCTURA
    { id: 1, seccion: "ESTRUCTURA", descripcion: "Limpieza general del equipo", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "ESTRUCTURA", descripcion: "Chequear fugas de aceite en cilindros", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "ESTRUCTURA", descripcion: "Comprobar si existen fugas de aceite en mangueras", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "ESTRUCTURA", descripcion: "Chequear el estado de los estabilizadores", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "ESTRUCTURA", descripcion: "Apriete de los bulones de la estructura", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "ESTRUCTURA", descripcion: "Comprobar el estado de los bulones (de ser necesario reemplazarlos)", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "ESTRUCTURA", descripcion: "Remover la grasa vieja en las partes con movimientos", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "ESTRUCTURA", descripcion: "Ingresar grasa en las partes con movimientos", condicion: "Buena", updatedAt: null },

    // EQUIPO DE TRABAJO
    { id: 9, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "EQUIPO DE TRABAJO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "EQUIPO DE TRABAJO", descripcion: "Reemplazar filtro de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el ajuste de los pernos", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el nivel de desgaste del deslizador de la pluma", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear las mangueras hidráulicas", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear las palancas de comandos", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear el desgaste de la pluma", condicion: "Buena", updatedAt: null }
  ],   "TRACTOR": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 13, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Comprobar fugas de aceite en el cinturón portafiltros", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 16, seccion: "ACCESORIOS", descripcion: "Comprobar el KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 18, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "CABINA", descripcion: "Comprobar y ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN / DIFERENCIAL
    { id: 22, seccion: "TRANSMISIÓN / DIFERENCIAL", descripcion: "Chequear Nivel de aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "TRANSMISIÓN / DIFERENCIAL", descripcion: "Reemplazar aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "TRANSMISIÓN / DIFERENCIAL", descripcion: "Comprobar el nivel de aceite diferencial", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "TRANSMISIÓN / DIFERENCIAL", descripcion: "Reemplazar aceite de diferencial", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 26, seccion: "ENGRASE", descripcion: "Realizar servicio de Engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 27, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las Baterías", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas (Modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarmas / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 30, seccion: "CHASIS", descripcion: "Ajuste de todos los pernos y tornillos", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "CHASIS", descripcion: "Comprobar el estado de la carrocería", condicion: "Buena", updatedAt: null },

    // HIDRÁULICO
    { id: 33, seccion: "HIDRÁULICO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null }
  ], 
  "RODILLO": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Apriete de tapa de cilindros", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar la presión de aceite", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Compruebe el indicador del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el depósito del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros principales de aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros secundarios de aire", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN
    { id: 19, seccion: "TRANSMISIÓN", descripcion: "Cambio aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "TRANSMISIÓN", descripcion: "Comprobar el nivel de aceite mandos finales", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "TRANSMISIÓN", descripcion: "Cambio aceite mandos finales", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "TRANSMISIÓN", descripcion: "Reemplazo filtros de transmisión", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "TRANSMISIÓN", descripcion: "Cambio filtro de aceite y O-ring", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 24, seccion: "ACCESORIOS", descripcion: "Comprobar el KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // EJES PORTALES / TRASERO
    { id: 26, seccion: "EJES PORTALES / TRASERO", descripcion: "Cambio de Aceite Diferenciales", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "EJES PORTALES / TRASERO", descripcion: "Reemplazo filtros", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar y engrasar las crucetas", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el nivel de aceite de los diferenciales", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el estado del cardan", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 31, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos (Camión y Grúa)", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "CABINA", descripcion: "Comprobar y ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },

    // FRENOS
    { id: 35, seccion: "FRENOS", descripcion: "Cambiar filtro de aire del circuito de frenos", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "FRENOS", descripcion: "Comprobar el funcionamiento de los Frenos", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "FRENOS", descripcion: "Drenar el agua del depósito de aire", condicion: "Buena", updatedAt: null },
    { id: 38, seccion: "FRENOS", descripcion: "Comprobar y ajustar la válvula de regulación de presión", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "FRENOS", descripcion: "Comprobar el apriete de las llantas", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "FRENOS", descripcion: "Comprobar la presión de los neumáticos", condicion: "Buena", updatedAt: null },
    { id: 41, seccion: "FRENOS", descripcion: "Comprobar y ajustar el freno de mano", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "FRENOS", descripcion: "Comprobar el desgaste de los frenos", condicion: "Buena", updatedAt: null },

    // DIRECCIÓN
    { id: 43, seccion: "DIRECCIÓN", descripcion: "Comprobar los cilindros de dirección", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "DIRECCIÓN", descripcion: "Comprobar el estado de las mangueras", condicion: "Buena", updatedAt: null },
    { id: 45, seccion: "DIRECCIÓN", descripcion: "Comprobar la alineación del volante", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 46, seccion: "ENGRASE", descripcion: "Realizar servicio de Engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 47, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las baterías", condicion: "Buena", updatedAt: null },
    { id: 48, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas", condicion: "Buena", updatedAt: null },
    { id: 49, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarma/bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 50, seccion: "CHASIS", descripcion: "Ajuste de todos los pernos", condicion: "Buena", updatedAt: null },
    { id: 51, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },
    { id: 52, seccion: "CHASIS", descripcion: "Comprobar el pasador frontal del bastidor", condicion: "Buena", updatedAt: null },
    { id: 53, seccion: "CHASIS", descripcion: "Comprobar y ajustar los pernos del equipo de trabajo", condicion: "Buena", updatedAt: null },

    // RODILLO
    { id: 54, seccion: "RODILLO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 55, seccion: "RODILLO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 56, seccion: "RODILLO", descripcion: "Comprobar el estado del rodillo", condicion: "Buena", updatedAt: null }
  ], "CAMION FUERA DE RUTA": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Apriete de tapa de cilindros", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Comprobar la presión de aceite", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Compruebe el indicador del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el depósito del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros principales de Aire", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros secundarios de Aire", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN
    { id: 20, seccion: "TRANSMISIÓN", descripcion: "Comprobar el estado de transmisión", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "TRANSMISIÓN", descripcion: "Comprobar el nivel de aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "TRANSMISIÓN", descripcion: "Cambio aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "TRANSMISIÓN", descripcion: "Comprobar nivel de aceite mandos finales", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "TRANSMISIÓN", descripcion: "Cambio aceite mandos finales", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "TRANSMISIÓN", descripcion: "Reemplazo filtros de transmisión", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "TRANSMISIÓN", descripcion: "Cambio filtro de aceite y O-ring", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 27, seccion: "ACCESORIOS", descripcion: "Comprobar el KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Pares / OyM", condicion: "Buena", updatedAt: null },

    // EJES PORTALES / TRASERO
    { id: 29, seccion: "EJES PORTALES / TRASERO", descripcion: "Cambio de Aceite Diferenciales", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "EJES PORTALES / TRASERO", descripcion: "Reemplazo filtros", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar y engrasar las crucetas", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el nivel de aceite de los diferenciales", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "EJES PORTALES / TRASERO", descripcion: "Comprobar el estado del cardan", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 34, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos (Camión y Grúa)", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CABINA", descripcion: "Comprobar y ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },

    // FRENOS
    { id: 38, seccion: "FRENOS", descripcion: "Cambiar filtro de aire del circuito de frenos", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "FRENOS", descripcion: "Comprobar el funcionamiento de los frenos", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "FRENOS", descripcion: "Drenar el agua del depósito de aire", condicion: "Buena", updatedAt: null },
    { id: 41, seccion: "FRENOS", descripcion: "Comprobar y ajustar la válvula de regulación de presión", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "FRENOS", descripcion: "Comprobar el apriete de las llantas", condicion: "Buena", updatedAt: null },
    { id: 43, seccion: "FRENOS", descripcion: "Comprobar la presión de los neumáticos", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "FRENOS", descripcion: "Comprobar y ajustar el freno de mano", condicion: "Buena", updatedAt: null },
    { id: 45, seccion: "FRENOS", descripcion: "Comprobar el desgaste de los frenos", condicion: "Buena", updatedAt: null },

    // DIRECCIÓN
    { id: 46, seccion: "DIRECCIÓN", descripcion: "Comprobar el tren delantero", condicion: "Buena", updatedAt: null },
    { id: 47, seccion: "DIRECCIÓN", descripcion: "Comprobar el estado de las mangueras", condicion: "Buena", updatedAt: null },
    { id: 48, seccion: "DIRECCIÓN", descripcion: "Comprobar la alineación del volante", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 49, seccion: "ENGRASE", descripcion: "Realizar servicio de Engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 50, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las baterías", condicion: "Buena", updatedAt: null },
    { id: 51, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces y limpia parabrisas", condicion: "Buena", updatedAt: null },
    { id: 52, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarma/bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 53, seccion: "CHASIS", descripcion: "Ajuste de todos los pernos", condicion: "Buena", updatedAt: null },
    { id: 54, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },
    { id: 55, seccion: "CHASIS", descripcion: "Comprobar el pasador frontal del bastidor", condicion: "Buena", updatedAt: null },
    { id: 56, seccion: "CHASIS", descripcion: "Comprobar el cilindro de levante de tolva", condicion: "Buena", updatedAt: null },
    { id: 57, seccion: "CHASIS", descripcion: "Comprobar el tren delantero", condicion: "Buena", updatedAt: null },

    // EQUIPO DE TRABAJO
    { id: 58, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar y ajustar los pernos del equipo de trabajo", condicion: "Buena", updatedAt: null },
    { id: 59, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el estado del equipo de trabajo", condicion: "Buena", updatedAt: null },
    { id: 60, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 61, seccion: "EQUIPO DE TRABAJO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null }
  ], 
  
  "AUTOELEVADORES": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (Principal, Secundario y Sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 13, seccion: "FILTROS DE AIRE", descripcion: "Compruebe el Indicador del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el Depósito del Filtro de Aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Principales de Aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los Filtros Secundarios de Aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y Ajustar el Cinturón Porta Filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 18, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // FRENOS
    { id: 20, seccion: "FRENOS", descripcion: "Chequear el estado de los frenos", condicion: "Buena", updatedAt: null },
    { id: 21, seccion: "FRENOS", descripcion: "Reemplazar líquido de frenos", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "FRENOS", descripcion: "Apriete de las ruedas", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "FRENOS", descripcion: "Comprobar el estado de los neumáticos", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 24, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "CABINA", descripcion: "Comprobar el Funcionamiento de todos los Controles de Operación", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "CABINA", descripcion: "Comprobar y ajustar las Palancas de Operación", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN
    { id: 28, seccion: "TRANSMISIÓN", descripcion: "Chequear Nivel de aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "TRANSMISIÓN", descripcion: "Reemplazar aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "TRANSMISIÓN", descripcion: "Comprobar el nivel de aceite de los diferenciales", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "TRANSMISIÓN", descripcion: "Reemplazar aceite de diferenciales", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "TRANSMISIÓN", descripcion: "Reemplazar aceite del convertidor de par", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "TRANSMISIÓN", descripcion: "Comprobar el estado de eje de tracción", condicion: "Buena", updatedAt: null },

    // ENGRASE
    { id: 34, seccion: "ENGRASE", descripcion: "Realizar servicio de Engrase en todos los puntos indicados por el manual de OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 35, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar el estado de las Baterías", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar Alarmas / Bocina", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 38, seccion: "CHASIS", descripcion: "Ajuste de Todos los Pernos y bulones", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "CHASIS", descripcion: "Chequear Pérdidas de Aceite", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "CHASIS", descripcion: "Chequear estribos y periféricos de estructura", condicion: "Buena", updatedAt: null },

    // TORRE DE TRABAJO
    { id: 41, seccion: "TORRE DE TRABAJO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "TORRE DE TRABAJO", descripcion: "Chequear el estado de las cadenas", condicion: "Buena", updatedAt: null },
    { id: 43, seccion: "TORRE DE TRABAJO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "TORRE DE TRABAJO", descripcion: "Comprobar el estado de la torre y rodamiento", condicion: "Buena", updatedAt: null },
    { id: 45, seccion: "TORRE DE TRABAJO", descripcion: "Comprobar el estado de las cadenas", condicion: "Buena", updatedAt: null }
  ],

  "GENERADOR": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (principal, secundario y sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Comprobar el estado del Turbo Cargador (modelos aplicables)", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar la presión de aceite", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Comprobar y ajustar el escape", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "MOTOR", descripcion: "Control y Apriete de la entrada de aire y conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Comprobar el indicador del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el depósito del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros principales de aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros secundarios de aire", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "ACCESORIOS", descripcion: "Comprobar Manuales de Partes / OyM", condicion: "Buena", updatedAt: null },

    // CONTROLES Y PANTALLAS
    { id: 21, seccion: "CONTROLES Y PANTALLAS", descripcion: "Chequear funcionamiento de los comandos del display", condicion: "Buena", updatedAt: null },

    // GENERADOR
    { id: 22, seccion: "GENERADOR", descripcion: "Limpiar generador", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "GENERADOR", descripcion: "Chequear ruidos o vibraciones inusuales", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "GENERADOR", descripcion: "Chequear las configuraciones de los sensores de temperatura (varía dependiendo del lugar de trabajo)", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "GENERADOR", descripcion: "Testear las cargas de la unidad 50% y 100%", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "GENERADOR", descripcion: "Chequear el estado de los rodamientos", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "GENERADOR", descripcion: "Chequear instalación eléctrica del cliente", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "GENERADOR", descripcion: "Comprobar equilibrio de las fases (Coseno Fi)", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "GENERADOR", descripcion: "Comprobar el estado del generador", condicion: "Buena", updatedAt: null },

    // EQUIPO
    { id: 30, seccion: "EQUIPO", descripcion: "Inspeccionar la caja de terminales de entrada y salida", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "EQUIPO", descripcion: "Comprobar los burletes de las puertas", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "EQUIPO", descripcion: "Comprobar el nivel de ruido de la unidad", condicion: "Buena", updatedAt: null }
  ], 

  "GRUA": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (principal, secundario y sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Limpiar Filtro Mallado Entrada Principal Bomba Inyectora", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Control y Apriete la entrada de aire y Conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 12, seccion: "FILTROS DE AIRE", descripcion: "Comprobar el indicador del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el depósito del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros principales de aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros secundarios de aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // TRANSMISIÓN
    { id: 17, seccion: "TRANSMISIÓN", descripcion: "Comprobar el estado de la Transmisión", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "TRANSMISIÓN", descripcion: "Comprobar Nivel de Aceite de Transmisión", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "TRANSMISIÓN", descripcion: "Cambio Aceite de Transmisión", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "TRANSMISIÓN", descripcion: "Cambio de Filtro de Aceite y O Ring", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 21, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "ACCESORIOS", descripcion: "Comprobar manuales de partes / OyM", condicion: "Buena", updatedAt: null },

    // EQUIPO DE TRABAJO
    { id: 23, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el estado de la pasteca y cables de izaje", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "EQUIPO DE TRABAJO", descripcion: "Comprobar el nivel de aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "EQUIPO DE TRABAJO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },

    // EJES
    { id: 26, seccion: "EJES", descripcion: "Cambio de grasa buje de las ruedas", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "EJES", descripcion: "Comprobar y ajustar la holgura del cojinete (ejes frontales)", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "EJES", descripcion: "Comprobar el nivel de reductor principal y reductor de llanta", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "EJES", descripcion: "Cambio de aceite reductor principal y reductor de la llanta", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "EJES", descripcion: "Reemplazo respiradero diferencial", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "EJES", descripcion: "Comprobar y engrasar las crucetas", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "EJES", descripcion: "Cambio de aceite diferenciales", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "EJES", descripcion: "Comprobar el estado de la suspensión", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 34, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos (Camión y Grúa)", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "CABINA", descripcion: "Comprobar Ruidos Inusuales", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los controles de operación", condicion: "Buena", updatedAt: null },

    // FRENOS
    { id: 37, seccion: "FRENOS", descripcion: "Cambiar filtro de aire del circuito de frenos", condicion: "Buena", updatedAt: null },
    { id: 38, seccion: "FRENOS", descripcion: "Comprobar el funcionamiento de los frenos", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "FRENOS", descripcion: "Drenar el agua del depósito de aire", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "FRENOS", descripcion: "Comprobar y ajustar la válvula de regulación de presión", condicion: "Buena", updatedAt: null },
    { id: 41, seccion: "FRENOS", descripcion: "Comprobar el apriete de las llantas", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "FRENOS", descripcion: "Comprobar el desgaste de los frenos", condicion: "Buena", updatedAt: null },

    // DIRECCIÓN
    { id: 43, seccion: "DIRECCIÓN", descripcion: "Comprobar el nivel de aceite de dirección", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "DIRECCIÓN", descripcion: "Comprobar y ajustar el sistema de dirección", condicion: "Buena", updatedAt: null },

    // SERVICIO / ENGRASE
    { id: 45, seccion: "SERVICIO / ENGRASE", descripcion: "Realizar Servicio de Engrase en todos los puntos indicados por el Manual de OyM (Camión)", condicion: "Buena", updatedAt: null },
    { id: 46, seccion: "SERVICIO / ENGRASE", descripcion: "Realizar Servicio de Engrase en todos los puntos indicados por el Manual de OyM (Grúa)", condicion: "Buena", updatedAt: null }
  ], 

  "TOPADOR": [
    // MOTOR
    { id: 1, seccion: "MOTOR", descripcion: "Cambio Aceite de Motor", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "MOTOR", descripcion: "Cambio Filtros de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "MOTOR", descripcion: "Cambio Filtros de Combustible (principal, secundario y sedimentación)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "MOTOR", descripcion: "Limpiar Filtro Mallado Entrada Principal Bomba Inyectora", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "MOTOR", descripcion: "Comprobar Nivel de Aceite Motor", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "MOTOR", descripcion: "Comprobar Nivel de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "MOTOR", descripcion: "Sustitución del Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "MOTOR", descripcion: "Control y Apriete las Abrazaderas del Circuito de Refrigerante", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "MOTOR", descripcion: "Comprobar la tensión de las Correas", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "MOTOR", descripcion: "Drenar Tanque de Combustible", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "MOTOR", descripcion: "Comprobar el funcionamiento del turbo cargador", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "MOTOR", descripcion: "Control y Apriete de las abrazaderas del turbo cargador", condicion: "Buena", updatedAt: null },
    { id: 13, seccion: "MOTOR", descripcion: "Control y Apriete de la entrada de aire y conectores", condicion: "Buena", updatedAt: null },

    // FILTROS DE AIRE
    { id: 14, seccion: "FILTROS DE AIRE", descripcion: "Comprobar el indicador del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "FILTROS DE AIRE", descripcion: "Limpiar el depósito del filtro de aire", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros principales de aire", condicion: "Buena", updatedAt: null },
    { id: 17, seccion: "FILTROS DE AIRE", descripcion: "Cambiar los filtros secundarios de aire", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "FILTROS DE AIRE", descripcion: "Comprobar y ajustar el cinturón porta filtro", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 19, seccion: "ACCESORIOS", descripcion: "Comprobar KIT de Herramientas", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "ACCESORIOS", descripcion: "Comprobar manuales de partes / OyM", condicion: "Buena", updatedAt: null },

    // SIST. ELÉCTRICO
    { id: 21, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar limpiaparabrisas", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "SIST. ELÉCTRICO", descripcion: "Comprobar luces", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "SIST. ELÉCTRICO", descripcion: "Chequear Alarmas/Bocina", condicion: "Buena", updatedAt: null },

    // EJES
    { id: 24, seccion: "EJES", descripcion: "Comprobar el nivel de aceite de los Mandos finales", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "EJES", descripcion: "Comprobar y ajustar la holgura de la cadena", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "EJES", descripcion: "Cambio de aceite mandos finales", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "EJES", descripcion: "Comprobar el estado de los rodillos", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "EJES", descripcion: "Comprobar el nivel de aceite de transmisión", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "EJES", descripcion: "Reemplazo aceite de transmisión (servicio 250 hs o inicial)", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "EJES", descripcion: "Chequear el estado de la rueda guía", condicion: "Buena", updatedAt: null },

    // CABINA
    { id: 31, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos", condicion: "Buena", updatedAt: null },
    { id: 32, seccion: "CABINA", descripcion: "Comprobar Ruidos inusuales", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los controles de operación", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "CABINA", descripcion: "Comprobar el funcionamiento de todos los instrumentos", condicion: "Buena", updatedAt: null },

    // CHASIS
    { id: 35, seccion: "CHASIS", descripcion: "Comprobar el estado del equipo de trabajo", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "CHASIS", descripcion: "Ajustar los pernos del equipo de trabajo", condicion: "Buena", updatedAt: null },
    { id: 37, seccion: "CHASIS", descripcion: "Chequear pérdidas de aceite", condicion: "Buena", updatedAt: null },

    // EQUIPO DE TRABAJO
    { id: 38, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear el estado del ripper", condicion: "Buena", updatedAt: null },
    { id: 39, seccion: "EQUIPO DE TRABAJO", descripcion: "Chequear el equipo de trabajo", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "EQUIPO DE TRABAJO", descripcion: "Reemplazar aceite hidráulico (2000 hrs)", condicion: "Buena", updatedAt: null },

    // ENGRASADO
    { id: 41, seccion: "ENGRASADO", descripcion: "Realizar Servicio de Engrase en todos los puntos indicados por el Manual de OyM", condicion: "Buena", updatedAt: null }
  ], 

  "BOMBA DE HORMIGON": [
    // CHASIS
    { id: 1, seccion: "CHASIS", descripcion: "Inspeccionar soportes de fijación", condicion: "Buena", updatedAt: null },
    { id: 2, seccion: "CHASIS", descripcion: "Chequear torque bulones de fijación", condicion: "Buena", updatedAt: null },
    { id: 3, seccion: "CHASIS", descripcion: "Chequear estado Gral. de chasis (fisuras / daños)", condicion: "Buena", updatedAt: null },
    { id: 4, seccion: "CHASIS", descripcion: "Chequear el estado de los estabilizadores", condicion: "Buena", updatedAt: null },
    { id: 5, seccion: "CHASIS", descripcion: "Chequear el estado de la pluma", condicion: "Buena", updatedAt: null },
    { id: 6, seccion: "CHASIS", descripcion: "Chequear nivel de aceite reductores de giro", condicion: "Buena", updatedAt: null },
    { id: 7, seccion: "CHASIS", descripcion: "Servicio de engrase pluma", condicion: "Buena", updatedAt: null },
    { id: 8, seccion: "CHASIS", descripcion: "Servicio de engrase tornamesa de giro", condicion: "Buena", updatedAt: null },
    { id: 9, seccion: "CHASIS", descripcion: "Chequear rodamientos / cadenas estabilizadores delanteros", condicion: "Buena", updatedAt: null },
    { id: 10, seccion: "CHASIS", descripcion: "Inspeccionar el estado del chasis (fisuras, oxido, etc.)", condicion: "Buena", updatedAt: null },
    { id: 11, seccion: "CHASIS", descripcion: "Chequear la rejilla de la tabla de carga", condicion: "Buena", updatedAt: null },
    { id: 12, seccion: "CHASIS", descripcion: "Chequear el estado de la Cabina", condicion: "Buena", updatedAt: null },

    // BOMBA
    { id: 13, seccion: "BOMBA", descripcion: "Chequear el estado portachapas trasero", condicion: "Buena", updatedAt: null },
    { id: 14, seccion: "BOMBA", descripcion: "Realizar servicio de engrase en todos los puntos indicados en tabla", condicion: "Buena", updatedAt: null },
    { id: 15, seccion: "BOMBA", descripcion: "Reemplazar el aceite de la tornamesa (reductor)", condicion: "Buena", updatedAt: null },
    { id: 16, seccion: "BOMBA", descripcion: "Reemplazar aceite", condicion: "Buena", updatedAt: null },

    // CAJA DE TRANSFERENCIA
    { id: 17, seccion: "CAJA DE TRANSFERENCIA", descripcion: "Inspeccionar nivel de aceite", condicion: "Buena", updatedAt: null },
    { id: 18, seccion: "CAJA DE TRANSFERENCIA", descripcion: "Inspeccionar el estado de las crucetas", condicion: "Buena", updatedAt: null },
    { id: 19, seccion: "CAJA DE TRANSFERENCIA", descripcion: "Chequear el torque de los bulones de fijación del plato", condicion: "Buena", updatedAt: null },
    { id: 20, seccion: "CAJA DE TRANSFERENCIA", descripcion: "Inspeccionar el estado de los ejes cardánicos", condicion: "Buena", updatedAt: null },

    // SISTEMA ELÉCTRICO
    { id: 21, seccion: "SISTEMA ELÉCTRICO", descripcion: "Comprobar el monitor y chequear el correcto funcionamiento", condicion: "Buena", updatedAt: null },
    { id: 22, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento del control remoto / cable", condicion: "Buena", updatedAt: null },
    { id: 23, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento de las teclas que accionan la pluma", condicion: "Buena", updatedAt: null },
    { id: 24, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento del cargador de baterías", condicion: "Buena", updatedAt: null },
    { id: 25, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento de todas las luces del tractor / bomba", condicion: "Buena", updatedAt: null },
    { id: 26, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento del sistema de arranque", condicion: "Buena", updatedAt: null },
    { id: 27, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento de todos los comandos caja trasera", condicion: "Buena", updatedAt: null },
    { id: 28, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento de todos los comandos en cabina", condicion: "Buena", updatedAt: null },
    { id: 29, seccion: "SISTEMA ELÉCTRICO", descripcion: "Chequear el funcionamiento de todos los comandos del control remoto", condicion: "Buena", updatedAt: null },
    { id: 30, seccion: "SISTEMA ELÉCTRICO", descripcion: "Resetear el monitor para iniciar ciclo de arranque", condicion: "Buena", updatedAt: null },
    { id: 31, seccion: "SISTEMA ELÉCTRICO", descripcion: "Comprobar el estado del controlador midamidronic", condicion: "Buena", updatedAt: null },

    // HIDRÁULICA
    { id: 32, seccion: "HIDRÁULICA", descripcion: "Reemplazar aceite", condicion: "Buena", updatedAt: null },
    { id: 33, seccion: "HIDRÁULICA", descripcion: "Chequear el estado de los acoples", condicion: "Buena", updatedAt: null },
    { id: 34, seccion: "HIDRÁULICA", descripcion: "Comprobar el filtro de aire en tanques", condicion: "Buena", updatedAt: null },
    { id: 35, seccion: "HIDRÁULICA", descripcion: "Comprobar el estado de la lanza", condicion: "Buena", updatedAt: null },
    { id: 36, seccion: "HIDRÁULICA", descripcion: "Comprobar el estado de las mangueras", condicion: "Buena", updatedAt: null },

    // SISTEMA HIDRÁULICO
    { id: 37, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar aceite hidráulico", condicion: "Buena", updatedAt: null },
    { id: 38, seccion: "SISTEMA HIDRÁULICO", descripcion: "Reemplazar filtros hidráulicos", condicion: "Buena", updatedAt: null },

    // CILINDROS / BOMBA / VÁLVULAS
    { id: 39, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Chequear fugas", condicion: "Buena", updatedAt: null },
    { id: 40, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el funcionamiento de los forzadores (radiador)", condicion: "Buena", updatedAt: null },
    { id: 41, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el nivel hidráulico", condicion: "Buena", updatedAt: null },
    { id: 42, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de las mangueras del circuito de giro", condicion: "Buena", updatedAt: null },
    { id: 43, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de las mangueras banco hid.", condicion: "Buena", updatedAt: null },
    { id: 44, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de las mangueras cilindro bombeo comando", condicion: "Buena", updatedAt: null },
    { id: 45, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado del banco hid. manual comando", condicion: "Buena", updatedAt: null },
    { id: 46, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de las mangueras banco hid. manual", condicion: "Buena", updatedAt: null },
    { id: 47, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de cilindros de bombeo", condicion: "Buena", updatedAt: null },
    { id: 48, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado del mezclador", condicion: "Buena", updatedAt: null },
    { id: 49, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el estado de los estabilizadores", condicion: "Buena", updatedAt: null },
    { id: 50, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el correcto funcionamiento grasera automática (Opcional)", condicion: "Buena", updatedAt: null },
    { id: 51, seccion: "CILINDROS / BOMBA / VÁLVULAS", descripcion: "Comprobar el correcto funcionamiento de los pistones", condicion: "Buena", updatedAt: null },

    // PISTONES DE BOMBO
    { id: 52, seccion: "PISTONES DE BOMBO", descripcion: "Chequear la hermeticidad en las camisas de refrigeración", condicion: "Buena", updatedAt: null },
    { id: 53, seccion: "PISTONES DE BOMBO", descripcion: "Comprobar fugas depósito de refrigeración camisas", condicion: "Buena", updatedAt: null },
    { id: 54, seccion: "PISTONES DE BOMBO", descripcion: "Comprobar el correcto funcionamiento de la válvula inversora bombeo / succión", condicion: "Buena", updatedAt: null },
    { id: 55, seccion: "PISTONES DE BOMBO", descripcion: "Reemplazar agua depósito de refrigeración de camisas", condicion: "Buena", updatedAt: null },
    { id: 56, seccion: "PISTONES DE BOMBO", descripcion: "Comprobar las ánillas de cierre y presión", condicion: "Buena", updatedAt: null },

    // VACIADO EN ENTREGA TÉCNICA
    { id: 57, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Reemplazar sellos de pistones", condicion: "Buena", updatedAt: null },
    { id: 58, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Capacitación a operadores auxiliar", condicion: "Buena", updatedAt: null },
    { id: 59, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Puntos de lubricación", condicion: "Buena", updatedAt: null },
    { id: 60, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Todas la funciones del control remoto", condicion: "Buena", updatedAt: null },
    { id: 61, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Reglas de seguridad", condicion: "Buena", updatedAt: null },
    { id: 62, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Operación de bombeo y limpieza de equipo", condicion: "Buena", updatedAt: null },
    { id: 63, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Acoplar y desacoplar bomba", condicion: "Buena", updatedAt: null },
    { id: 64, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Diferentes métodos de limpieza", condicion: "Buena", updatedAt: null },
    { id: 65, seccion: "VACIADO EN ENTREGA TÉCNICA", descripcion: "Peligro de congelamiento depósito de refrigeración camisas", condicion: "Buena", updatedAt: null },

    // ACCESORIOS
    { id: 66, seccion: "ACCESORIOS", descripcion: "Control de niveles", condicion: "Buena", updatedAt: null },
    { id: 67, seccion: "ACCESORIOS", descripcion: "Medidas de emergencia en caso de fallas", condicion: "Buena", updatedAt: null },
    { id: 68, seccion: "ACCESORIOS", descripcion: "Mantenimiento preventivo diario", condicion: "Buena", updatedAt: null },
    { id: 69, seccion: "ACCESORIOS", descripcion: "Comprobar pelota de lavado", condicion: "Buena", updatedAt: null },
    { id: 70, seccion: "ACCESORIOS", descripcion: "Comprobar cargador con 2 baterías", condicion: "Buena", updatedAt: null },
    { id: 71, seccion: "ACCESORIOS", descripcion: "Comprobar el KIT de herramientas", condicion: "Buena", updatedAt: null },
    { id: 72, seccion: "ACCESORIOS", descripcion: "Comprobar manuales de partes / OyM", condicion: "Buena", updatedAt: null }
  ]
};
